import { Expose, Transform, Type } from 'class-transformer'

import { Base } from './Base'
import { Pallet } from './Pallet'
import { Order } from './Order'

export class OrderPallet extends Base {
  @Expose({ name: 'pallet' })
  @Transform(({ pallet }) => pallet?.guid)
  guid: string = ''

  @Type(() => Order)
  order?: Order

  @Type(() => Pallet)
  pallet?: Pallet
}
